import React from 'react';
import ReactDOM from 'react-dom';

import {Sequence} from 'components/Sequence';
import {MOLBIO_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import AssemblyHistoryTabContents from 'molbio/visual-history/assembly-history/AssemblyHistoryTabContents';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import VisualHistoryTabView from '../VisualHistoryTabView';
import AssemblyHistoryTabState from './AssemblyHistoryTabState';

export default class AssemblyHistoryTabView<
  Polymer extends Sequence | AaSequence,
> extends VisualHistoryTabView<Polymer, AssemblyHistoryTabState<Polymer>> {
  override viewedEvent = MOLBIO_ANALYTICS_ACTIONS.VIEWED_ASSEMBLY_HISTORY_TAB;

  override registerListeners(): void {
    // Listen for change events on both protein and sequence models which store their open version ID
    // under a different attribute name.
    this.listenTo(this.model.polymer(), 'change:activeVersionId change:protein', this.render.bind(this));
  }

  override render(): this {
    renderToDOM(
      <AssemblyHistoryTabContents
        polymerId={this.model.polymer().id}
        activeVersionId={this.model.polymer().getActiveVersionId()}
        showingCurrentVersion={this.model.polymer().isLatest()}
      />,
      this.el
    );
    return this;
  }

  override remove(): this {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}
